import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
const { API_URL, STRIPE_RETURN_URL, STRIPE_CANCEL_URL, STRIPE_ERROR_URL } = environment;
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Travel, TravelDocument, TravelInfo } from 'src/app/models/travel';
import { PaymentForm } from 'src/app/models/paymentForm';

@Injectable({
  providedIn: 'root'
})
export class TravelService {

  constructor(
    private http: HttpClient,
  ) { }

  async get(token: string, id: number | string): Promise<Travel> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.get<Travel>(`${API_URL}/travels/${id}`, { headers }).toPromise();
  }

  async setPrice(token: string, id: number | string, price: number): Promise<any> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.post<Travel>(`${API_URL}/travels/${id}/price`, { price }, { headers }).toPromise();
  }

  async pickup(token: string, id: number | string, code: string): Promise<any> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.post(`${API_URL}/travels/${id}/pickup`, { code }, { headers }).toPromise();
  }

  async dropoff(token: string, id: number | string, code: string): Promise<any> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.post(`${API_URL}/travels/${id}/dropoff`, { code }, { headers }).toPromise();
  }

  async remove(token: string, id: number | string): Promise<any> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.delete(`${API_URL}/travels/${id}`, { headers }).toPromise();
  }

  async getDocuments(token: string, travelId: number | string): Promise<TravelDocument[]> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.get<TravelDocument[]>(`${API_URL}/travels/${travelId}/documents`, { headers }).toPromise();
  }

  async uploadDocument(
    token: string,
    travelId: number | string,
    payload: { buffer: string; mimeType: string; documentType?: string }
  ): Promise<TravelDocument> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.post<TravelDocument>(`${API_URL}/travels/${travelId}/documents`, payload, { headers }).toPromise();
  }

  async deleteDocument(token: string, travelId: number | string, documentId: number): Promise<void> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.delete<void>(`${API_URL}/travels/${travelId}/documents/${documentId}`, { headers }).toPromise();
  }

  async updateInfo(token: string, id: number | string, info: TravelInfo): Promise<Travel> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.patch<Travel>(`${API_URL}/travels/${id}/info`, info, { headers }).toPromise();
  }

  async pay(token: string, id: number | string): Promise<PaymentForm> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });

    // return this.http.post<PaymentForm>(`${API_URL}/travels/${id}/pay-fake`, {}, { headers })
    //   .toPromise()
    //   .then(res => res || { paymentFormUrl: '' });

    const body = {
      returnUrl: STRIPE_RETURN_URL,
      cancelUrl: STRIPE_CANCEL_URL,
      errorUrl: STRIPE_ERROR_URL
    };
    return this.http.post<PaymentForm>(`${API_URL}/travels/${id}/pay_speedline`, body, { headers }).toPromise();
  }
}
